import React, { useState, useEffect } from "react";
import Rotator from "../../../../../Assets/Images/ButtonLoadingIcon.svg";

import axios from "axios";
import { Config } from "../../../../../Config";
import Select from "../../ShareElements/Select/Select";

const MainSettings = (props) => {
  const [IsLoading, setIsLoading] = useState(false);
  const [LangConfig, setLangConfig] = useState({});
  const [PreselectedLang, setPreselectedLang] = useState();
  const [LanguageOptions] = useState([
    {
      name: "English",
      id: "EN",
    },
    {
      name: "German",
      id: "DE",
    },
    // {
    //   name: "French",
    //   id: "FR",
    // },
    // {
    //   name: "Spanish",
    //   id: "ES",
    // },
  ]);
  const [PhotoSize, setPhotoSize] = useState();
  const [ZipSize, setZipSize] = useState();
  const [AssistifyUploadLimits, setAssistifyUploadLimits] = useState({});

  useEffect(() => {
    getSelectedLanguage();
    getUploadLimitConfig();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const disableSaveBtn = () => {
    props.SetHasUnsavedChanges(false);
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
  };
  const getSelectedLanguage = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/session-timeout",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        var Language = Res.data.filter((Obj) => {
          return Obj["name"] === "LANGUAGE";
        });
        setLangConfig(Language[0]);
        if (Language[0].value === "EN") {
          // document.getElementById("pre-selected-language").innerHTML =
          //   "English";
          setPreselectedLang(LanguageOptions[0]);
        } else if (Language[0].value === "FR") {
          // document.getElementById("pre-selected-language").innerHTML = "French";
          // setPreselectedLang("FR");
        } else if (Language[0].value === "ES") {
          // document.getElementById("pre-selected-language").innerHTML =
          //   "Spanish";
          // setPreselectedLang("ES");
        } else if (Language[0].value === "DE") {
          // document.getElementById("pre-selected-language").innerHTML =
          //   "Spanish";
          setPreselectedLang(LanguageOptions[1]);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const getUploadLimitConfig = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/upload-limit",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setPhotoSize(Res.data.photoSizeLimitKb);
        setZipSize(Res.data.zipSizeLimitMb);
        setAssistifyUploadLimits({
          assistityFileSizeLimitKb: Res.data.assistityFileSizeLimitKb,
          assistityFileZipSizeLimitMb: Res.data.assistityFileZipSizeLimitMb,
        });
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const validateZipSize = () => {
    const ZIPSize = document.getElementById("zip-size").value;
    const ZipSizeCorrect = ZIPSize > 0 && ZIPSize <= 200;
    if (!ZipSizeCorrect) {
      document.getElementById("zip-size").classList.add("wrong-state");
      document.getElementById("validation-text").style.color = "#ff7474";
      window.localStorage.setItem("HasUnsaveChanges", 1);
      return false;
    }
    return true;
  };

  const validateAssistifyZipSize = () => {
    const ZIPSize = document.getElementById("assistify-zip-size").value;
    const ZipSizeCorrect = ZIPSize > 0 && ZIPSize <= 200;
    if (!ZipSizeCorrect) {
      document
        .getElementById("assistify-zip-size")
        .classList.add("wrong-state");
      document.getElementById("assistify-validation-text").style.color =
        "#ff7474";
      window.localStorage.setItem("HasUnsaveChanges", 1);
      return false;
    }
    return true;
  };

  const validateAssistifyFileSize = () => {
    const PhotoSize = document.getElementById("file-size").value;
    const PhotoSizeCorrect = PhotoSize > 0 && PhotoSize <= 500;
    if (!PhotoSizeCorrect) {
      document.getElementById("file-size").classList.add("wrong-state");
      document.getElementById("assistify-validation-text").style.color =
        "#ff7474";
      window.localStorage.setItem("HasUnsaveChanges", 1);
      return false;
    }
    return true;
  };

  const validatePhotoSize = () => {
    const PhotoSize = document.getElementById("photo-size").value;
    const PhotoSizeCorrect = PhotoSize > 0 && PhotoSize <= 500;
    if (!PhotoSizeCorrect) {
      document.getElementById("photo-size").classList.add("wrong-state");
      document.getElementById("validation-text").style.color = "#ff7474";
      window.localStorage.setItem("HasUnsaveChanges", 1);
      return false;
    }
    return true;
  };
  const ConvertPreSelectedToValue = {
    German: "DE",
    English: "EN",
  };

  const handleSave = async () => {
    if (
      ConvertPreSelectedToValue[PreselectedLang.name] !==
      document.getElementById("language-previous-value").value
    ) {
      if (document.getElementById("language-previous-value").value) {
        await changeLang();
      }
    }
    await updateUploadSize();
  };

  const updateUploadSize = () => {
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/upload-limit",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        photoSizeLimitKb: document.getElementById("photo-size").value,
        zipSizeLimitMb: document.getElementById("zip-size").value,
        assistityFileSizeLimitKb: document.getElementById("file-size").value,
        assistityFileZipSizeLimitMb:
          document.getElementById("assistify-zip-size").value,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setZipSize(Res.data.zipSizeLimitMb);
        setPhotoSize(Res.data.photoSizeLimitKb);
        setAssistifyUploadLimits({
          assistityFileSizeLimitKb: Res.data.assistityFileSizeLimitKb,
          assistityFileZipSizeLimitMb: Res.data.assistityFileZipSizeLimitMb,
        });
        disableSaveBtn();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const changeLang = () => {
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/language",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        id: LangConfig.id,
        name: LangConfig.name,
        type: LangConfig.type,
        value: document.getElementById("language-previous-value").value,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        disableSaveBtn();
        getSelectedLanguage();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const enableSave = () => {
    props.SetHasUnsavedChanges(true);
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
  };

  const handleInputChange = (Id, ValidationTextId) => {
    const ZipSizeIsValid = validateZipSize();
    const AssistifyZipSizeIsValid = validateAssistifyZipSize();
    const PhotoSizeIsValid = validatePhotoSize();
    const AssistifyFileSizeIsValid = validateAssistifyFileSize();
    if (
      ZipSizeIsValid &&
      PhotoSizeIsValid &&
      AssistifyZipSizeIsValid &&
      AssistifyFileSizeIsValid
    ) {
      document.getElementById("photo-size").classList.remove("wrong-state");
      document.getElementById("zip-size").classList.remove("wrong-state");
      document.getElementById("file-size").classList.remove("wrong-state");
      document
        .getElementById("assistify-zip-size")
        .classList.remove("wrong-state");
      document.getElementById(ValidationTextId).style.color = "#8b96a6";
      enableSave();
      return;
    }
    disableSaveBtn();
  };

  return (
    <div className="main-content security-settings app-settings-form">
      <div className="user-management-form">
        <section className="form-header">
          <h1>{translateText("main_settings")}</h1>
          <div className="button-group">
            {IsLoading ? (
              <button
                onClick={() => null} //this button is disabled and won't act when loading is set to true
                id="save-btn"
                className="save no-action"
              >
                <img alt="" className="rotator" src={Rotator} />
              </button>
            ) : (
              <button
                onClick={() => handleSave()}
                id="save-btn"
                className="save disabled"
              >
                {translateText("save")}
              </button>
            )}
          </div>
        </section>
        <section className="form-body single-field-form">
          <h1 className="section-title">{translateText("language")}</h1>
          <div className="row">
            <h1>{translateText("language_settings")}</h1>
            {PreselectedLang ? (
              <Select
                Initial={PreselectedLang.name}
                Options={LanguageOptions}
                IsWithId
                Id={"language"}
                PreSelected={true}
                PreSelectedId={PreselectedLang.id}
                ChangeHandler={() => enableSave()}
                ValidationError="Please specify the scope."
              />
            ) : null}
          </div>
          <span className="hr-line"></span>
          <h1 className="section-title">{translateText("photo_uploader")}</h1>
          <div className="row uploader">
            <h1 className="photo-uploader-description">
              {translateText("photo_size")} <p className="required">*</p>
            </h1>
            <input
              onChange={() =>
                handleInputChange("photo-size", "validation-text")
              }
              defaultValue={PhotoSize}
              min={1}
              max={500}
              className="photo-uploader"
              type="number"
              id="photo-size"
            />
            <p className="info-text">KB</p>
          </div>
          <div className="row uploader">
            <h1 className="photo-uploader-description">
              {translateText("zip_file_size")} <p className="required">*</p>
            </h1>
            <input
              onChange={() => handleInputChange("zip-size", "validation-text")}
              defaultValue={ZipSize}
              min={1}
              max={200}
              className="photo-uploader"
              type="number"
              id="zip-size"
            />
            <p className="info-text">MB</p>
          </div>
          <p className="info-bottom" id="validation-text">
            <i className="feather-alert-circle" />
            <span>
              {translateText("file_uploader_warning_1")} {"500KB "}
              {translateText("file_uploader_warning_2")}
              {" 200MB."}
            </span>
          </p>
          <span className="hr-line"></span>
          <h1 className="section-title">
            {translateText("assistify_file_uploader")}
          </h1>
          <div className="row uploader">
            <h1 className="photo-uploader-description">
              {translateText("file_size")} <p className="required">*</p>
            </h1>
            <input
              onChange={() =>
                handleInputChange("file-size", "assistify-validation-text")
              }
              defaultValue={AssistifyUploadLimits.assistityFileSizeLimitKb}
              min={1}
              max={500}
              className="photo-uploader"
              type="number"
              id="file-size"
            />
            <p className="info-text">KB</p>
          </div>
          <div className="row uploader">
            <h1 className="photo-uploader-description">
              {translateText("zip_file_size")} <p className="required">*</p>
            </h1>
            <input
              onChange={() =>
                handleInputChange(
                  "assistify-zip-size",
                  "assistify-validation-text"
                )
              }
              defaultValue={AssistifyUploadLimits.assistityFileZipSizeLimitMb}
              min={1}
              max={200}
              className="photo-uploader"
              type="number"
              id="assistify-zip-size"
            />
            <p className="info-text">MB</p>
          </div>
          <p className="info-bottom" id="assistify-validation-text">
            <i className="feather-alert-circle" />
            <span>
              {translateText("file_uploader_warning_1")} {"500KB "}
              {translateText("file_uploader_warning_2")}
              {" 200MB."}
            </span>
          </p>
        </section>
      </div>
    </div>
  );
};

export default MainSettings;
